import { useState } from "react";
import API_ROUTES from "./apiRoutes";

export const useSignup = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const getErrorMessage = (error) => {
    // Verificar se é um erro do Prisma com código P2002 (duplicate key)
    if (error && typeof error === 'object' && error.message && error.message.code === 'P2002') {
      return "Este e-mail já está cadastrado. Por favor, use outro e-mail ou faça login.";
    }
    
    // Verificar se é uma string que contém o código P2002
    if (typeof error === 'string' && error.includes('P2002')) {
      return "Este e-mail já está cadastrado. Por favor, use outro e-mail ou faça login.";
    }

    // Verificar se é uma string JSON que contém o código P2002
    if (typeof error === 'string') {
      try {
        const parsedError = JSON.parse(error);
        if (parsedError && parsedError.code === 'P2002') {
          return "Este e-mail já está cadastrado. Por favor, use outro e-mail ou faça login.";
        }
      } catch (e) {
        // Se não conseguir fazer parse, continua com as outras verificações
      }
      
      // Verificar se contém 'duplicate key' ou 'already exists'
      if (error.includes('duplicate key') || error.includes('already exists')) {
        return "Este e-mail já está cadastrado. Por favor, use outro e-mail ou faça login.";
      }
    }

    // Verificar se é uma resposta da API com o erro P2002
    if (error && typeof error === 'object' && error.message && 
        typeof error.message === 'object' && error.message.code === 'P2002') {
      return "Este e-mail já está cadastrado. Por favor, use outro e-mail ou faça login.";
    }

    switch (error.toLowerCase()) {
      case 'invalid email':
        return "Por favor, insira um e-mail válido.";
      case 'password too short':
        return "A senha deve ter pelo menos 6 caracteres.";
      case 'invalid password':
        return "A senha deve conter letras e números.";
      case 'name required':
        return "Por favor, insira seu nome.";
      default:
        return "Ocorreu um erro ao criar sua conta. Por favor, tente novamente.";
    }
  };

  const signup = async ({ name, email, password }) => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    if (!name || !email || !password) {
      setError("Por favor, preencha todos os campos.");
      setLoading(false);
      return;
    }

    try {
      const response = await fetch(API_ROUTES.SIGNUP.default(), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ name, email, password }),
      });

      const data = await response.json();

      if (!response.ok) {
        // Se a resposta contém uma mensagem de erro estruturada, use ela diretamente
        if (data.message && typeof data.message === 'object') {
          throw new Error(JSON.stringify(data.message));
        }
        // Caso contrário, use a mensagem padrão
        throw new Error(data.message || "Erro ao cadastrar usuário.");
      }

      if (data.token) {
        localStorage.setItem("token", data.token);
      }
      setSuccess(true);
    } catch (err) {
      setError(getErrorMessage(err.message));
    } finally {
      setLoading(false);
    }
  };

  return { signup, success, loading, error };
}; 